import { observer } from 'mobx-react';

import styles from './SelectOrganizationItem.module.scss';

import { OptionType } from '@components/Select';
import { CheckboxList } from '@components/CheckboxList';

interface Props {
    organization: OptionType<string>;
    selectedValues: string[];
    onOrganizationSelect(organizationIds: string[]): void;
}

export const SelectOrganizationItem = observer(({ selectedValues, onOrganizationSelect, organization }: Props) => (
    <div className={styles.root}>
        <CheckboxList
            options={[organization]}
            onChange={onOrganizationSelect}
            selectedValues={selectedValues}
        />
    </div>
));
